import React from "react";
import { useSelector } from "react-redux";
import ClassProduct from "../../Common/ClassProduct";
import Order from "../../Common/Order";
import OtherUser from "../../Common/OtherUser";
import Payment from "../../Common/Payment";
import UserBuyer from "../../Common/UserBuyer";

const Index = ({ data }) => {
  const { user } = useSelector(state => state);
  return (
    <div>
      <ClassProduct pro={data.product} />
      <Order order={data.order} />
      <Payment payment={data.peyment} />
      {user.role != "user" ? <UserBuyer userbuyer={data.user_buyer} /> : <></>}
      <OtherUser other={data.otheruser} />
    </div>
  );
};

export default Index;
